import { render, staticRenderFns } from "./General.vue?vue&type=template&id=6eccb146&scoped=true"
import script from "./General.vue?vue&type=script&lang=js"
export * from "./General.vue?vue&type=script&lang=js"
import style0 from "./General.vue?vue&type=style&index=0&id=6eccb146&prod&lang=css"
import style1 from "./General.vue?vue&type=style&index=1&id=6eccb146&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eccb146",
  null
  
)

export default component.exports